import VFooter from './VFooter';

VFooter.install = function install(Vue) {
  Vue.component(VFooter.name, VFooter);
};

export default VFooter;


//////////////////
// WEBPACK FOOTER
// ./~/vuetify/es5/components/VFooter/index.js
// module id = TWha
// module chunks = 0